import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class ServiceDetails extends Component {

    render() {

    let publicUrl = process.env.PUBLIC_URL+'/'
    let imagealt = 'image'

    return	<section className="service-details">
			  <div className="container">
			    <div className="row">
			      <div className="col-lg-6 clearfix">
			        <img src={publicUrl+"assets/images/resources/service-d-moc-1.png"} alt={ imagealt } className="float-right wow fadeInLeft" data-wow-duration="1500ms" />
			      </div>{/* /.col-lg-6 */}
			      <div className="col-lg-6">
			        <div className="service-details__content">
			          <h3>Software Does The <br /> Work But You're Always <br /> In Correct Soluation</h3>
			          <p>Specializing in unique digital solutions, our skilled team contributes a depth of expertise and knowledge to every project. We take pride in exceeding our clients' expectations and delivering exceptional results. Whether it's lead generation, social media marketing, email marketing, content marketing, website design and development, or SEO, we offer a comprehensive range of services tailored to meet your specific needs and budget. Join us to unlock your digital potential, establish a strong online presence, and achieve your business goals.</p>
			          <Link to="/service" className="service-details__link">Continue Reading</Link>{/* /.service-details__link */}
			        </div>{/* /.service-details__content */}
			      </div>{/* /.col-lg-6 */}
			    </div>{/* /.row */}
			    <div className="row">
			      <div className="col-lg-6">
			        <img src={publicUrl+"assets/images/resources/service-d-moc-2.png"} alt={ imagealt } className="wow fadeInRight" data-wow-duration="1500ms" />
			      </div>{/* /.col-lg-6 */}
			      <div className="col-lg-6">
			        <div className="service-details__content">
			          <h3>We Help To Grow Your <br /> Business Growth</h3>
			          <ul className="list-unstyled service-details__list">
			            <li>
						We offer comprehensive digital marketing solutions to drive tangible results and maximize your business growth.
			            </li>
			            <li>Our services include lead generation, paid advertisements, social media marketing, email marketing, content marketing, and SEO.</li>
			            <li>Partner with us to benefit from our expertise and strategies, ensuring an exceptional user experience, increased brand visibility, and a strong online presence.</li>
			          </ul>{/* /.list-unstyled service-details__list */}
			          <Link to="/service" className="service-details__link">Continue Reading</Link>{/* /.service-details__link */}
			        </div>{/* /.service-details__content */}
			      </div>{/* /.col-lg-6 */}
			    </div>{/* /.row */}
			  </div>{/* /.container */}
			</section>

        }
}

export default ServiceDetails